module.exports = {"410222001":"咸平街道","410222101":"竖岗镇","410222102":"玉皇庙镇","410222103":"四所楼镇","410222104":"朱砂镇","410222105":"长智镇","410222200":"冯庄乡","410222201":"孙营乡","410222202":"大岗李乡","410222203":"邸阁乡","410222204":"练城乡","410222205":"厉庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410222.json
// module id = 1654
// module chunks = 0